/**
 * Constants for the AcquisitionBundle
 * These should match the PHP constants defined in AcquisitionBundle\Constants\AcquisitionConstants
 */

export const ACQUISITION_CONSTANTS = {
    /**
     * Long message threshold for quality calculation
     * Messages with this many characters or more get maximum quality points
     * This value is used throughout the acquisition process for validation and quality calculation
     */
    LONG_MESSAGE_THRESHOLD: 225,

    /**
     * Short message threshold for quality calculation
     */
    SHORT_MESSAGE_THRESHOLD: 175
};

// Export individual constants for easier importing
export const LONG_MESSAGE_THRESHOLD = ACQUISITION_CONSTANTS.LONG_MESSAGE_THRESHOLD;
export const SHORT_MESSAGE_THRESHOLD = ACQUISITION_CONSTANTS.SHORT_MESSAGE_THRESHOLD;
